import { render, staticRenderFns } from "./station-ad-history.vue?vue&type=template&id=4580a060&scoped=true&"
import script from "./station-ad-history.vue?vue&type=script&lang=js&"
export * from "./station-ad-history.vue?vue&type=script&lang=js&"
import style0 from "./station-ad-history.vue?vue&type=style&index=0&id=4580a060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580a060",
  null
  
)

export default component.exports